module.exports = __webpack_public_path__ + "img/01.21995afc.jpg";